<template>
	<div>
		<list-filter
				:data-statuses="statuses"
				:data-authors="authors"
				:data-categories="categories"
				:data-endpoint="endPoint"
				:data-url-params="urlParams"
		></list-filter>
		<div class="table-lister table-responsive">
			<table>
				<thead>
				<tr>
					<th>
						ID
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Article</span>
						</div>
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">URL Slug</span>
						</div>
					</th>
					<th>
						Author
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Last Updated</span>
						</div>
					</th>
					<th>
						Misc
					</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="article in list">
					<td>{{ article.id }}</td>
					<td>
						<a :href="'/' + selectedSite.slug + '/articles/' + article.id +'/edit/?tab=content'"
						   class="article-title"><strong>{{ article.title }}</strong></a>
						<div class="article-links">
							<span v-if="article.status === 'scheduled'" class="badge badge-danger">Scheduled</span>
							<span v-if="article.inUse" class="badge badge-danger">Article is currently in use</span>
							<span v-if="article.draftStatus === 1" class="badge badge-warning">Is Draft</span>
							<span v-if="article.draftStatus === 2" class="badge badge-primary">Has Draft</span>
							<span v-if="article.status === 'archived'" class="badge badge-warning">Archived</span>
							<span v-if="categories.hasOwnProperty(article.category)" class="badge badge-default"
								  title="Category">{{ categories[article.category].title }}</span>
							<a :href="'/' + selectedSite.slug + '/articles/' + article.id +'/edit/?tab=content'">Edit</a>
							<a v-if="categories.hasOwnProperty(article.category)"
							   :href="selectedSite.url + '/' + categories[article.category].slug + '/' + article.slug + '/'" target="_blank">View</a>
						</div>
					</td>
					<td>{{ article.slug }}</td>
					<td v-if="authors.hasOwnProperty(article.author_id)">{{ authors[article.author_id].full_name }}</td>
					<td v-if="!authors.hasOwnProperty(article.author_id)">none</td>
					<td>{{ article.lastUpdateTime }}</td>
					<td>
						<span v-if="!article.tag && article.category === 3" class="badge badge-danger">No TAG Set</span>
						<span v-if="!article.tag && article.category !== 3" class="badge badge-warning">No TAG Set</span>
						<span v-if="article.tag">{{ article.tag }}</span>
						<div class="article-links">
						comments: {{ article.comments }}
						</div>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		dataEndpoint: {
			type: String
		},
		dataSelectedSite: {
			type: Object
		},
		dataArticlesList: {
			type: Object
		},
		dataUrlParams: {
			type: Object,
			required: false
		},
	},
	data() {
		return {
			endPoint: this.dataEndpoint,
			selectedSite: this.dataSelectedSite,
			articlesList: this.dataArticlesList || [],
			urlParams: this.dataUrlParams || [],

			list: this.dataArticlesList.allArticles,
			categories: this.dataArticlesList.categories,
			authors: this.dataArticlesList.authors,
			statuses: this.dataArticlesList.statuses,
		}
	},
}
</script>

<style scoped>

</style>
